import { apiClient } from "lib/apiClient";
import {
  IMarketAreaLimits,
  IMarketAreaSettings,
} from "features/MarketAreas/types";

export interface IPatchMarketAreaSettingsPayload {
  limits?: Partial<IMarketAreaLimits>;
}

export const patchMarketAreaSettings = async (
  payload: IPatchMarketAreaSettingsPayload
): Promise<IMarketAreaSettings> => {
  const response = await apiClient.patch<IMarketAreaSettings>(
    "/admin/market-areas/settings",
    payload
  );

  return response.data;
};
